import styled from '@emotion/styled';
import React from 'react';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import EditAppInfo from '../EditAppInfo';

function FormDialog({ open, handleClose, handleAdd, dialogTitle, textLabel }) {
  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>{dialogTitle}</DialogTitle>
      <DialogContent>
        <strong style={{ display: "block" }}>Attach active file</strong>
        <input accept='image/png' type="file" id='attachedFile' />
        <br /><br />
        <strong style={{ display: "block" }}>Attach inactive file</strong>
        <input accept='image/png' type="file" id='greyImage' />
        <TextField
          autoFocus
          margin="dense"
          id="content"
          label={textLabel}
          type="text"
          fullWidth
          variant="standard"
          inputProps={{ maxLength: 50 }}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} size="small">Cancel</Button>
        <Button onClick={handleAdd} variant="contained" size="small">Add</Button>
      </DialogActions>
    </Dialog>
  );
}

const ImageTextListManager = ({
  navTitle,
  dialogTitle,
  textLabel,
  getData,
  addData,
  deleteData,
  columns = ["Active Image", "Inactive image", textLabel],
  editTitle,
  editAllowIcon = true,
  setProfileNavTitle,
  __constants,
  __snackBarText,
  __snackBarSeverity,
  mainContext,
}) => {
  const { setSnackBar } = React.useContext(mainContext);
  const [open, setOpen] = React.useState(false);
  const [dataList, setDataList] = React.useState([]);
  const [imgChanged, setImgChanged] = React.useState(false);

  const callSnackBar = (msg, type) => {
    setSnackBar({
      status: true,
      text: msg,
      severity: __snackBarSeverity[type]
    });
  };

  const handleClickOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const fetchData = async () => {
    const res = await getData();
    if (res && res.status === 500) return callSnackBar(__snackBarText.internalServerError, "error");
    if (res.data.status !== 200) return callSnackBar(res.data.errors?.[0]?.message || "Error", "error");
    if (!res.data.data.data?.length) return callSnackBar("No data found", "info");
    setDataList(res.data.data.data);
  };

  const handleAdd = async () => {
    const name = document.getElementById("content").value;
    const file = document.getElementById("attachedFile");
    const greyImage = document.getElementById("greyImage");
    if (file.files.length === 0 || greyImage.files.length === 0) return callSnackBar("Please add image", "warning");
    let idxDot = file.files[0].name.lastIndexOf(".") + 1;
    let extFile = file.files[0].name.substr(idxDot).toLowerCase();
    if (extFile !== "png") return alert("Only png files are allowed!");
    idxDot = greyImage.files[0].name.lastIndexOf(".") + 1;
    extFile = greyImage.files[0].name.substr(idxDot).toLowerCase();
    if (extFile !== "png") return alert("Only png files are allowed!");
    if (!name) return callSnackBar(`Write ${textLabel.toLowerCase()}`, "warning");
    const res = await addData(name, file.files[0], greyImage.files[0]);
    setDataList([...dataList, res.data.data]);
    callSnackBar("Data added successfully", "success");
    file.value = null;
    handleClose();
  };

  const handleDelete = async (id) => {
    const res = await deleteData(id);
    if (res && res.status === 500) return callSnackBar(__snackBarText.internalServerError, "error");
    if (res.data.status !== 200) return callSnackBar(res.data.errors?.[0]?.message || "Error", "error");
    setDataList(dataList.filter(item => item._id !== id));
    callSnackBar("Data deleted successfully", "success");
  };

  React.useEffect(() => {
    fetchData();
    setProfileNavTitle(navTitle);
    // eslint-disable-next-line
  }, []);

  const handleUpdate = (index, data) => {
    let temp = [...dataList];
    temp[index] = data;
    setDataList(temp);
    setImgChanged(!imgChanged);
  };

  return (
    <>
      <FormDialog open={open} handleClose={handleClose} handleAdd={handleAdd} dialogTitle={dialogTitle} textLabel={textLabel} />
      <Conatiner>
        <Header>
          <Button variant="contained" size='small' onClick={handleClickOpen}>Add new</Button>
        </Header>
        <Body>
          <List>
            {columns.map((col, i) => <div className="header" key={i}>{col}</div>)}
            <div></div>
            <div></div>
          </List>
          <Divider className='divider-gap' />
          {dataList.map((item, index) => (
            <List key={item._id}>
              <div>
                <ImgDiv>
                  <img src={`${__constants.images}${item.file}?${imgChanged + Date.now()}`} alt="" />
                </ImgDiv>
              </div>
              <div>
                <ImgDiv>
                  <img src={`${__constants.images}${item.greyImage}?${imgChanged + Date.now()}`} alt="" />
                </ImgDiv>
              </div>
              <div>{item.name}</div>
              <div>
                <EditAppInfo
                  file={__constants.images + item.file}
                  greyImage={__constants.images + item.greyImage}
                  title={editTitle}
                  name={item.name}
                  id={item._id}
                  allowIcon={editAllowIcon}
                  cb={(data) => handleUpdate(index, data)}
                />
              </div>
              <div>
                <Button size="small" color="error" onClick={() => handleDelete(item._id)}>Delete</Button>
              </div>
            </List>
          ))}
        </Body>
      </Conatiner>
    </>
  );
};

const Conatiner = styled("div")`
  .divider-gap{ margin: 0.5rem 0; }
  button{ text-transform: none; }
`;
const Header = styled("div")`
  button{ border-radius: 5px; }
`;
const Body = styled("div")`
  height: 80vh;
`;
const List = styled("div")`
  margin-top: 1rem;
  display: flex;
  align-items: center;
  .header{ font-family: "semi-bold"; font-size : 90% }
  &>div:nth-child(1){ width: 25%; }
  &>div:nth-child(2){ width: 25%; }
  &>div:nth-child(3){ width: 100%; }
  &>div:nth-child(4){ width: 5%; }
  &>div:nth-child(5){ width: 10%; }
`;
const ImgDiv = styled("div")`
  height: 2rem;
  width: 2.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  &>img{ width: 100%; object-fit: contain; clip-path: circle(); }
`;

export default ImageTextListManager;